import { emptyPriceInformation, PriceInformation } from "../../../../zustand/payment/checkout/paymentTypes";
import usePaymentCheckoutState from "../../../../zustand/payment/checkout/paymentCheckoutState";
import { usePaymentCheckoutAboDuoState } from "../../../../zustand/payment/checkout/paymentCheckoutAboDuoState";
import { usePaymentCheckoutAboFamilyState } from "../../../../zustand/payment/checkout/paymentCheckoutAboFamilyState";
import { usePaymentCheckoutAboBasicState } from "../../../../zustand/payment/checkout/paymentCheckoutAboBasicState";
import { usePaymentCheckoutCourseState } from "../../../../zustand/payment/checkout/paymentCheckoutCourseState";

export const shCheckoutCurrentPriceInformation = () => {
    let currentPriceInformation: PriceInformation = emptyPriceInformation;

    const buyMode = usePaymentCheckoutState.getState().buyMode;
    const currentProduct = usePaymentCheckoutState.getState().currentProduct;

    const aboDuoPrice = usePaymentCheckoutAboDuoState.getState().priceInformation;
    const aboFamilyPrice = usePaymentCheckoutAboFamilyState.getState().priceInformation;
    const aboBasicPrice = usePaymentCheckoutAboBasicState.getState().priceInformation;

    const coursePrice = usePaymentCheckoutCourseState.getState().priceInformation;

    if (buyMode === "abo") {
        if (!currentProduct) {
            currentPriceInformation = emptyPriceInformation;
        } else if (currentProduct.tag === "duo") {
            currentPriceInformation = aboDuoPrice;
        } else if (currentProduct.tag === "family") {
            currentPriceInformation = aboFamilyPrice;
        } else {
            currentPriceInformation = aboBasicPrice;
        }
    } else {
        currentPriceInformation = coursePrice;
    }

    return currentPriceInformation;

}
